var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('google-map',{attrs:{"sharer":_vm.sharer,"show-lengend":_vm.showLegend,"map-style":"elevation","show-sites":false,"legend":_vm.legend}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }